import { RouteObject } from 'react-router-dom';

import SidebarLayout from 'src/layouts/SidebarLayout';
import Attributes from './content/applications/Attributes';
import Brands from './content/applications/Brands';
import Product from './content/applications/Products';
import StaffAccount from './content/applications/StaffAccount';
import Tag from './content/applications/Tags';
import Login from 'src/content/applications/Login';
import ProductVariants from 'src/content/applications/ProductVariants';
import Orders from './content/applications/Orders';
import AdminDetails from './content/applications/AdminDetails';
import Sellers from './content/applications/Sellers';
import Perks from './content/applications/Perks';
import Scrapper from './content/applications/Scrapper';
import OrderManagement from './content/applications/OrderManagement';
import DiscountManagement from './content/applications/Discounts';
import Referral from './content/applications/Referral';
import ReferralUsage from './content/applications/ReferralUsage';
import ReferralPayout from './content/applications/ReferralPayout';

const Loader = (Component) => (props) => <Component {...props} />;

// Status

interface RouterParams {
  to: string;
  element: React.ReactNode;
}

const AdminRoutes: RouterParams[] = [
  {
    to: 'attributes',
    element: <Attributes />
  },
  {
    to: 'brands',
    element: <Brands />
  },

  {
    to: 'product',
    element: <Product />
  },
  {
    to: 'staff-account',
    element: <StaffAccount />
  },
  {
    to: 'tags',
    element: <Tag />
  },
  {
    to: '',
    element: <Login />
  },
  {
    to: 'product-variants',
    element: <ProductVariants />
  },
  {
    to: 'orders',
    element: <Orders />
  },
  {
    to: 'sellers',
    element: <Sellers />
  },
  {
    to: 'perks',
    element: <Perks />
  },
  {
    to: 'admin-details',
    element: <AdminDetails />
  }
  ,{
    to: 'scrapper',
    element: <Scrapper />
  },{
    to: 'order-admin',
    element: <OrderManagement />
  },{
  to: 'discount-management',
    element: <DiscountManagement/>
  },{
    to: 'referral',
    element: <Referral />
  },{
    to: 'referral-usage',
    element: <ReferralUsage />
  },{
    to: 'referral-payouts',
    element: <ReferralPayout />
  }
];

// Check if the localStorage is set
const accessToken = localStorage.getItem('accessToken');

// @ts-ignore
const routes: RouteObject[] = [
  {
    path: '',
    element: <SidebarLayout />,
    children: [
      {
        path: '*',
        element: <Login />
      },
      {
        path: './admin-details',
        element: <AdminDetails />
      },
      ...AdminRoutes.map((route) => ({
        path: accessToken === null ? '*' : route.to,
        element: accessToken === null ? <Login /> : route.element
      }))
    ]
  }
];

export default routes;
